var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "time-line",
        { staticClass: "historial-line mt-4" },
        _vm._l(_vm.visibleItems, function(item) {
          return _c(
            "time-line-item",
            {
              key: `History-${item.id}`,
              scopedSlots: _vm._u(
                [
                  {
                    key: "date",
                    fn: function() {
                      return [
                        _c(
                          "span",
                          { staticClass: "color-secondary-6 font-12" },
                          [_vm._v("Fecha:")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$formatDate(
                                    item.createdDate,
                                    _vm.$templateDate.longDateWithHour
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [
              _c(
                "div",
                {
                  staticClass: "row align-items-center",
                  attrs: { id: "main-info" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-2 additional-evaluation ml-2 mt-1"
                    },
                    [
                      _c("custom-balloon", {
                        attrs: {
                          "background-color": item.status.color,
                          dot: "",
                          text: item.status?.name
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-3 mt-3 mt-md-0 mt-sm-3" },
                    [
                      _c("div", { staticClass: "color-secondary-6 font-14" }, [
                        _vm._v(" Usuario: ")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "color-black font-16 font-weight-normal"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("capitalize")(item.userFullName)) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        }),
        1
      ),
      _c("div", { staticClass: "row" }, [
        _vm.canShowMore
          ? _c(
              "div",
              { staticClass: "col-12 d-flex justify-content-center my-3" },
              [
                _c(
                  "action-button",
                  {
                    attrs: {
                      variant:
                        "outline-success custom-view-more actionButton rounded-pill"
                    },
                    on: { click: _vm.loadMore }
                  },
                  [
                    _vm._v(" Ver más "),
                    _c("i", { staticClass: "ml-1 fas fa-chevron-down" })
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-2" }, [
      _c("i", { staticClass: "mr-2 fas fa-clock mb-1 text-orange" }),
      _c("label", { staticClass: "font-16 color-black font-weight-bold" }, [
        _vm._v(" Historial de Estatus ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }